import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../components/PageHeader";
import {getDownloadAdminFile, getLogs} from "../../api/backup/BackupService";
import ZipFile from '../../resources/icon/zipfile.png'

/** 요청 처리율 현황 */
const SystemLogs = () => {
    const [size, setSize] = useState(500);
    const [data, setData] = useState();

    const fetchData = async (size) => {
        getLogs(size).then(r => {
            if(r.status === 200){
                setData(r.data)
            }
        });
    }

    useEffect(() => {
        fetchData(size);
    }, [])

    return (
        <div className={"common-container"}>
            <PageHeader header={"시스템 로그"} />
            <div className={"border-[1px] p-[1rem] mb-2 flex"}>
                <div className={"mr-2"}>시스템 로그 출력 라인 수 : </div>
                <input type={"number"} max={"2000"}
                       onChange={(e) => {
                            if(e.target.value > 2000){
                                alert("2000이하의 숫자만 가능합니다")
                                setSize(0);
                            }else{
                                setSize(e.target.value)
                            }
                        }}
                       onKeyDown={(e) => {
                            if(e.key === "Enter"){
                                fetchData(size);
                            }
                        }}
                       className={"border-black inline-block pl-1"} value={size}
                />
                <img src={ZipFile} className={"ml-auto cursor-pointer h-6 w-6"} onClick={() => getDownloadAdminFile("log")} />
            </div>

            <div className={"border-[1px] p-[1rem] mb-2 h-[650px]"}>
                <pre className={"border-[1px] w-full h-full overflow-y-auto"}>{data && data.join('\n')}</pre>
            </div>
        </div>
    );
};

export default SystemLogs;